import {onBeforeUnmount, watch} from 'vue'
import {useKeyboardShortcutStore} from '@toolify/client/src/stores/KeyboardShortcutStore/useKeyboardShortcutStore'
import {$ref} from '@vue-macros/reactivity-transform/macros'
import {IKeyboardShortcut} from '@toolify/client/src/stores/KeyboardShortcutStore/types/IKeyboardShortcut'
import {UseKeyboardShortcutsOptions} from '@toolify/client/src/modules/keyboard/types/UseKeyboardShortcutsOptions'

export function useKeyboardShortcuts(
  shortcuts: [
    IKeyboardShortcut['keys'],
    IKeyboardShortcut['callback']
  ][],
  rule?: () => boolean,
  options?: UseKeyboardShortcutsOptions,
) {
  const scope = Symbol()
  const keyboardShortcutStore = useKeyboardShortcutStore()
  let shortcutIds = $ref<symbol[]>([])

  onBeforeUnmount(() => {
    unregisterShortcuts()
  })

  const registerShortcuts = () => {
    keyboardShortcutStore.createScope(scope)
    shortcutIds = keyboardShortcutStore.registerShortcuts(shortcuts.map(shortcut => {
      return {
        keys: shortcut[0],
        callback: shortcut[1],
        ...(options?.commonShortcutType != null
          ? {commonShortcutType: options.commonShortcutType}
          : {}),
        ...(options?.moreImportantThan != null && options.moreImportantThan.length > 0
          ? {moreImportantThan: options.moreImportantThan}
          : {}),
        ...(options?.preventDefault === false ? {preventDefault: false} : {}),
        ...(options?.skipWhileTyping ? {skipWhileTyping: true} : {}),
      }
    }), scope)
  }

  const unregisterShortcuts = () => {
    keyboardShortcutStore.deleteShortcutsByIds(shortcutIds)
    keyboardShortcutStore.deleteScope(scope)
    shortcutIds = []
  }

  if (rule) {
    watch(() => rule(), (value) => {
      if (value) {
        registerShortcuts()
      } else {
        unregisterShortcuts()
      }
    }, {
      immediate: true,
      flush: 'sync',
    })
  } else {
    watch(() => true, () => registerShortcuts(), {immediate: true})
  }

  return {
    registerShortcuts,
    unregisterShortcuts,
  }
}
